// Group G3's own words (Action Center, SLA and metrics): the KPI names, the Req health drivers, the gate titles, the
// Action Center's tabs and kinds, the response word and the Workbench filter words. Each quotes the vendored glossary
// or design-system excerpts verbatim (labels.test.mjs checks the quote, the text and the pending status). Words the
// shared module already carries (SLA tiers, health bands, Calendar/Active Time, verbs) are imported, not repeated.

import { defineLabels, template } from "../labels";

const KPI_WORDS = "*Open Requisitions · Active Candidates · Time to Acceptance · Offers Accepted · Req health* · §7 measures";
const RING_WORDS = "*Req health* · *Search Readiness* · n/N gates";
const CLOCK_WORDS = "*Calendar Time* · *Active Time* · *Days on Hold* · *Time to Acceptance* · *Time to Fill* · \"SLA uses Active Time\" · 60 / 75 / 90";
const DRIVER_WORDS = "driver names from §7 (*Overdue review*, *HM responsiveness*, *Days open*, *Panel decline/nonresponse*, *Availability/conflict delays*)";
const GATE_WORDS = "*Offer readiness* · *Ready for Verbal Offer* · *Debrief readiness* · *Ready / Not Ready* · *Coverage validator* · *Validation Failed / Ready* · *Search Readiness* · *Missing prerequisites* · *All candidates dispositioned* · *Record outcome* · *Release*";
const AROW_WORDS = "*Action Center* · *Prioritized actions* · *History* · the nine kinds · verbs §17 · \"Deep link to exact screen\"";
const HIST_WORDS = "`.hist` shows `pill.ok` *Completed* + *by {actor} · {date/time}*";
const KINDS = "Prioritized actions across reqs, candidates, scheduling, packets, scorecards, panels, approvals, offers and closeout.";
const SELECT_WORDS = "*To schedule* (from \"debriefs to schedule\") · the eight statuses · *Scheduling SLA risk*";
const HEAT_WORDS = "the five values · the rounds · owners · *Uncovered*";
const HOLD_DAYS = "dashed gold dot + `pill.warn` *On Hold · 4 days*";

export const METRIC_LABELS = /* @__PURE__ */ defineLabels({
  openRequisitions: { text: "Open Requisitions" },
  activeCandidates: { text: "Active Candidates" },
  timeToAcceptance: { text: "Time to Acceptance" },
  offersAccepted: { text: "Offers Accepted" },
  reqHealth: { text: "Req health" },
  searchReadiness: { text: "Search Readiness" },
  timeToFill: { text: "Time to Fill" },
  days: { text: "days" },
  overdueReview: { text: "Overdue review" },
  hmResponsiveness: { text: "HM responsiveness" },
  daysOpen: { text: "Days open" },
  panelDeclineNonresponse: { text: "Panel decline/nonresponse" },
  availabilityConflictDelays: { text: "Availability/conflict delays" },
  debriefReadiness: { text: "Debrief readiness" },
  allCandidatesDispositioned: { text: "All candidates dispositioned" },
  actionCenter: { text: "Action Center" },
  prioritizedActions: { text: "Prioritized actions" },
  history: { text: "History" },
  completed: { text: "Completed" },
  toSchedule: { text: "To schedule" },
  schedulingSlaRisk: { text: "Scheduling SLA risk" },
  uncovered: { text: "Uncovered" },
});

/** The nine Action Center kinds, in his order (G §2); the row draws the kind as its icon, a filter as these words. */
export const ACTION_KIND_LABELS = /* @__PURE__ */ defineLabels({
  reqs: { text: "reqs" },
  candidates: { text: "candidates" },
  scheduling: { text: "scheduling" },
  packets: { text: "packets" },
  scorecards: { text: "scorecards" },
  panels: { text: "panels" },
  approvals: { text: "approvals" },
  offers: { text: "offers" },
  closeout: { text: "closeout" },
});

export const METRIC_TEMPLATES = {
  nDays: /* @__PURE__ */ template({ text: "{n} days" }),
  completedBy: /* @__PURE__ */ template({ text: "by {actor} · {at}" }),
  healthName: /* @__PURE__ */ template({ text: "Req health {n}, {band}: {k} drivers" 


}),
} as const;
